import { v4 as uuidv4 } from 'uuid';
import defaultProfile from './data/profile.json';
import { getProfileAPI } from './api';

function minutesToLabel(mins) {
    if (!mins) return '0m';
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

function buildProfileDisplay(p) {
    const density = p.scheduleDensity || {};
    const location = p.detectedLocation || {};
    const totalMins = density.totalCalendarMinutesMonth || 1;
    const bookedMins = density.timeBookedMinutesMonth || 0;
    const firstName = p.firstName || '';
    const lastName = p.lastName || '';

    return {
        displayName:        `${firstName} ${lastName}`.trim(),
        firstName,
        lastName,
        email:              p.email || '',
        avatarInitials:     p.avatarInitials || `${firstName[0] || ''}${lastName[0] || ''}`.toUpperCase(),
        personaType:        p.personaType || '',
        role:               p.role || '',

        city:               location.city || '',
        country:            location.country || '',
        timezone:           location.timezone || '',
        connectedDevices:   (p.connectedDevices || []).join(', '),

        engagementScore:    p.engagementScore || 0,
        engagementTotal:    p.engagementTotal || 1000,
        engagementPct:      Math.round(((p.engagementScore || 0) / (p.engagementTotal || 1000)) * 100 * 10) / 10,
        rankingPublisher:   p.rankingPublisher ? `#${p.rankingPublisher}` : '—',
        rankingCountry:     p.rankingCountry   ? `#${p.rankingCountry.toLocaleString()}` : '—',
        rankingWorld:       p.rankingWorld     ? `#${p.rankingWorld.toLocaleString()}` : '—',
        rankingCountryName: location.country || '',

        eventsThisMonth:    density.eventImpressionsMonth || 0,
        timeBookedLabel:    minutesToLabel(bookedMins),
        scheduleDensityPct: Math.round((bookedMins / totalMins) * 100 * 10) / 10,
    };
}

async function getProfile(session) {
    if (session.payload) {
        const merged = { ...defaultProfile, ...session.payload };
        this.profile = merged;
        this.profileDisplay = buildProfileDisplay(merged);
        this.observed.profile = uuidv4();
    }

    const res = await getProfileAPI({
        store: this,
        token: session.token,
        traceId: this.env.traceId,
    });

    if (res?.data?.data) {
        const merged = { ...defaultProfile, ...session.payload, ...res.data.data };
        this.profile = merged;
        this.profileDisplay = buildProfileDisplay(merged);
        this.observed.profile = uuidv4();
    }
}

export default getProfile;
